import { query } from '../../../../muster-react/src';
import routerSchema from './router.schema';
import Router from './router';

export default query(routerSchema)(Router);

